import { render } from "./Team.vue?vue&type=template&id=c5bdd342"
import script from "./Team.vue?vue&type=script&lang=js"
export * from "./Team.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "c5bdd342"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c5bdd342', script)) {
    api.reload('c5bdd342', script)
  }
  
  module.hot.accept("./Team.vue?vue&type=template&id=c5bdd342", () => {
    api.rerender('c5bdd342', render)
  })

}

script.__file = "resources/js/Pages/User/Partials/Team.vue"

export default script